<script lang="ts">
  import ManualPayrollEntry from '../../components/admin/payroll/ManualPayrollEntry.svelte';
</script>

<div class="manual-payroll-entry-page">
  <ManualPayrollEntry />
</div>

<style>
  .manual-payroll-entry-page {
    min-height: 100vh;
    background-color: #f9fafb;
  }
</style> 